import UpdateResetPassword from '@nile/banyan/src/Pebbles/update-reset-password/update-reset-password';
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import {
  getHeaderValue,
  toast,
  AppLoader,
  AppContext,
  fetchApi
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import queryString from 'query-string';

const CreateNewPasswordParent = styled.div`
  height: 100%;
`;

const CreateNewPasswordPage = (props) => {
  const { history } = props;
  const [loader, setLoader] = useState(true);
  const [renderType, setRenderType] = useState('updatePassword');

  const appContext = useContext(AppContext);

  // useEffect(() => {
  //   validateToken();
  // }, []);

  useEffect(() => {
    if (appContext.languageData) validateToken();
  }, [appContext.languageData]);

  const validateToken = async () => {
    const token = queryString.parse(props.location.search).token;
    const requestOptions = {
      method: 'GET',
      credentials: 'include',
      headers: getHeaderValue()
    };
    const validationResponse = await fetchApi(
      `${envConfig.loginRoot}/user/validateactivationtoken?token=${token}`,
      requestOptions
    );

    const validationResponseBool = await validationResponse.json();
    if (validationResponse.status === 200 && validationResponseBool) {
      setLoader(false);
    } else {
      if (!validationResponseBool) {
        toast('error', `app.errorCode.expired.email.link`);
        history.push(`/login`);
      }
      //Mapping error code other than 200
      else if (validationResponse.status !== 200) {
        toast('error', `app.errorCode.${validationResponse.status}`);
      }
    }
  };
  if (loader)
    return (
      <CreateNewPasswordParent className="flex center jcenter ">
        <AppLoader />
      </CreateNewPasswordParent>
    );
  return <UpdateResetPassword createPassword renderType={renderType} />;
};

export default withRouter(CreateNewPasswordPage);
